// removed by extract-text-webpack-plugin
module.exports = {"btn":"btn___19Doc","bg":"bg___1Zn3E","wrapper":"wrapper___hMm3r","dt":"dt___osOO0","dd":"dd___1jr-A","header":"header___2JxBM","h3":"h3___2oDDh","close":"close___2jB5Z","content":"content___3Fz44","row":"row___dtCSw","pageContent":"pageContent___1z0fl","column":"column___e15rD","loading":"loading___jdGPQ"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/Variations/styles.scss
// module id = 472
// module chunks = 0